export const isNumeric = (value) => {
    if ((value === null) || (value === undefined) || (value === "")) {
        return false;
    }
    return !isNaN(+value);
}
export const validId = (id) => {
    if ((id === null) || (id === undefined)) {
        return false;
    }
    if (typeof (id) === "string") {
        id = Number.parseInt(id, 10);
        if (Number.isNaN(id)) {
            return false;
        }
    } else if (typeof (id) !== "number") {
        return false;
    }
    if (!Number.isInteger(id)) {
        return false;
    }
    if ((id < 1) || (id > 9999999)) {
        return false;
    }
    return true;
}
export const formatNumber = (value, decimalPlaces = 0) => {
    if (!isNumeric(value)) {
        return "";
    } else {
        const numberFormat = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces
        });
        return numberFormat.format(value)
    }
}
export const formatItems = (value, items, decimalPlaces = 0) => {
    if (!isNumeric(value)) {
        return "";
    } else {
        let
            item;

        switch (items) {
            case "people":
                item = "person";
                break;
            default:
                item = items.slice(0, -1);
                break;
        }

        if (decimalPlaces === 0) {
            return `${formatNumber(value, 0)} ${Math.round(value) === 1 ? item : items}`;
        } else {
            return `${formatNumber(value, decimalPlaces)} ${items}`;
        }
    }
}

export const formatCurrency = (value, decimalPlaces = 0) => {
    if (!isNumeric(value)) {
        return "";
    } else {
        const usd = new Intl.NumberFormat('en-US', {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces
        });
        return usd.format(value)
    }
}
export const formatPercent = (value, decimalPlaces = 0) => {
    if (!isNumeric(value)) {
        return "";
    } else {
        const percentFormat = new Intl.NumberFormat('en-US', {
            style: "percent",
            minimumFractionDigits: decimalPlaces,
            maximumFractionDigits: decimalPlaces
        });
        return percentFormat.format(value / 100)
    }
}

export const stringToNumber = (s) => {
    return parseFloat(s.replace(/[^0-9.]/g, ""));
}
export const formatDate = (date) => {
    return `${date.toLocaleDateString('en-US', {
        dateStyle: "short",
    })} ${date.toLocaleTimeString('en-US', {
        timeStyle: "short",
    })}`;
}
// export const formatDateAndTimeFromUtcString = (dateString) => {
//     const date = new Date(dateString);

//     // Format using Intl.DateTimeFormat
//     return new Intl.DateTimeFormat('en-US', {
//         year: '2-digit',
//         month: '2-digit',
//         day: '2-digit',
//         hour: '2-digit',
//         minute: '2-digit',
//         hour12: true, // Ensures 12-hour format with AM/PM
//         timeZoneName: 'short' // Local timezone handling
//     }).format(date);
// }

// export const formatItems = (n, item) => {
//     if (n === 1) {
//         return `${n} ${item}`;
//     } else {
//         return `${n} ${item}s`;
//     }
// }

// export const parseAndFormatDate = (dateString) => {
//     const parsedDate = Date.parse(dateString);
//     if (!isNaN(parsedDate)) {
//         const date = new Date();
//         return `${date.toLocaleDateString('en-US', {
//             dateStyle: "short",
//         })} ${date.toLocaleTimeString('en-US', {
//             timeStyle: "short",
//         })}`;
//     }
// }

export const getColor = (index) => {
    const colors = [
        "#4C7289",
        "#DB8925",
        "#7D1327",
        "#8A8D32",
        "#6F625A"
    ];
    return colors[index % colors.length];
}